export default __webpack_public_path__ + "static/media/Spiritark Gloves.40d6627e.jpg";